import { apiClient } from '../client';

export interface CardChangeLog {
  id: number;
  cardId: number;
  userId: number;
  userName: string;
  userEmail: string;
  action: string;
  fieldName?: string;
  oldValue?: string;
  newValue?: string;
  changeTimestamp: string;
  details?: string;
}

export interface CardChangeLogsResponse {
  content: CardChangeLog[];
  totalElements: number;
  totalPages: number;
  size: number;
  number: number;
}

export const cardChangeLogsApi = {
  getChangeLogs: async (cardId: number, page = 0, size = 20): Promise<CardChangeLogsResponse> => {
    return await apiClient.get<CardChangeLogsResponse>(`/cards/${cardId}/change-logs`, {
      params: { page, size }
    });
  },

  exportToExcel: async (cardId: number): Promise<Blob> => {
    return await apiClient.get<Blob>(`/cards/${cardId}/change-logs/export`, {
      responseType: 'blob'
    });
  }
};
